import { render, staticRenderFns } from "./transactionRecords.vue?vue&type=template&id=3b19ab12&scoped=true&"
import script from "./transactionRecords.vue?vue&type=script&lang=js&"
export * from "./transactionRecords.vue?vue&type=script&lang=js&"
import style0 from "./transactionRecords.vue?vue&type=style&index=0&id=3b19ab12&lang=less&scoped=true&"
import style1 from "./transactionRecords.vue?vue&type=style&index=1&id=3b19ab12&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b19ab12",
  null
  
)

export default component.exports